module.exports = __webpack_public_path__ + "img/knife_css.75798039.svg";